import React from 'react';
import { CheckSquare, Share, Edit3, Archive, ArchiveRestore, FolderInput, Trash2 } from 'lucide-react';
import './ui/MenuSurface.css';

const ContextMenu = ({
  contextMenu,
  showingArchived,
  toggleSelectMode,
  shareChat,
  startRenaming,
  archiveChat,
  unarchiveChat,
  showMoveModal,
  showDeleteModal
}) => {
  if (!contextMenu.visible) return null;

  return (
    <div
      className="arrow-menu-surface arrow-chat-context-menu fixed z-50"
      style={{
        left: contextMenu.x,
        top: contextMenu.y,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={toggleSelectMode}
        className="arrow-menu-item"
      >
        <CheckSquare size={18} strokeWidth={2} className="arrow-menu-icon" />
        <span className="arrow-menu-label">Select</span>
      </button>

      <div className="arrow-menu-divider" />

      <button
        onClick={() => shareChat(contextMenu.chatId)}
        className="arrow-menu-item"
      >
        <Share size={18} strokeWidth={2} className="arrow-menu-icon" />
        <span className="arrow-menu-label">Share</span>
      </button>

      <button
        onClick={() => startRenaming(contextMenu.chatId)}
        className="arrow-menu-item"
      >
        <Edit3 size={18} strokeWidth={2} className="arrow-menu-icon" />
        <span className="arrow-menu-label">Rename</span>
      </button>

      <button
        onClick={() => showMoveModal(contextMenu.chatId)}
        className="arrow-menu-item"
      >
        <FolderInput size={18} strokeWidth={2} className="arrow-menu-icon" />
        <span className="arrow-menu-label">Move to Workspace</span>
      </button>

      <div className="arrow-menu-divider" />

      {showingArchived ? (
        <button
          onClick={() => unarchiveChat(contextMenu.chatId)}
          className="arrow-menu-item"
        >
          <ArchiveRestore size={18} strokeWidth={2} className="arrow-menu-icon" />
          <span className="arrow-menu-label">Unarchive</span>
        </button>
      ) : (
        <button
          onClick={() => archiveChat(contextMenu.chatId)}
          className="arrow-menu-item"
        >
          <Archive size={18} strokeWidth={2} className="arrow-menu-icon" />
          <span className="arrow-menu-label">Archive</span>
        </button>
      )}
      <button
        onClick={() => showDeleteModal(contextMenu.chatId)}
        className="arrow-menu-item arrow-menu-item-danger"
      >
        <Trash2 size={18} strokeWidth={2} className="arrow-menu-icon" />
        <span className="arrow-menu-label">Delete</span>
      </button>
    </div>
  );
};

export default ContextMenu;
